<template>
  <div>
    <title-edit header="FAQ" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Category* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :model="form.category_id" :items="optionCategory" @update="updateCategory"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Question TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.question_th" @update="updateQuestionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Question EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.question_en" @update="updateQuestionEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Answer TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.answer_th" @update="updateAnswerTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Answer EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.answer_en" @update="updateAnswerEN"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteFaq"/>
      <preview-button />
      <save-button @click.native="saveFaq"/>
    </div>
  </div>
</template>

<script>
  import TitleEdit from "../../components/TitleHeader/TitleEdit";
  import LineHr from "../../components/Icon/line-hr";
  import SelectOption from "../../components/Input/selectOption";
  import InputTextField from "../../components/Input/InputTextField";
  import DeleteButton from "../../components/Button/DeleteButton";
  import PreviewButton from "../../components/Button/PreviewButton";
  import SaveButton from "../../components/Button/SaveButton";
  import {mapState} from "vuex";
  export default {
    name: "Faq.vue",
    components: {
      SaveButton,
      PreviewButton, DeleteButton, InputTextField, SelectOption, LineHr, TitleEdit},
    data(){
      return{
        optionCategory:[],
      }
    },
    computed: {
      ...mapState({
        form: state => {
          return state.Faq.form;
        }
      })
    },
    created() {
      this.getFaqCategoryAll();
    },
    methods:{
      getFaqCategoryAll(){
        this.$store.dispatch("FaqCategory/getFaqCategoryAll").then(res=>{
          this.optionCategory = [
            { text: "Select", value: "" },
            ...res.map(type => ({
              value: type.category_id,
              text: type.category_name
            }))
          ];
        })
      },
      validateData(){
        if(!this.form.category_id){
          alert('Please Select Category');
          return false;
        }else if(!this.form.question_th){
          alert('Please input Question TH');
          return false;
        }else if(!this.form.question_en){
          alert('Please input Question EN');
          return false;
        }else if(!this.form.answer_th){
          alert('Please input Answer TH');
          return false;
        }else if(!this.form.answer_en){
          alert('Please input Answer EN');
          return false;
        }
        else{
          return true;
        }
      },
      saveFaq(){
        if(this.validateData()){
          this.$store.dispatch("Faq/saveFaq",{
            id : this.form.id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg);
            if(res.response_code == 200){
              this.goToFaq();
            }
          }).catch(()=>{
            alert("cannot save Faq data");
          })
        }
      },
      goToFaq(){
        this.$router.push("/fag/faqs");
      },
      deleteFaq(){
        this.$store.dispatch("Faq/deleteFaq",this.form.id).then(res=>{
          alert(res.response_msg);
          if(res.response_code == 200){
            this.goToFaq();
          }
        }).catch(()=>{
          alert("cannot delete Faq data");
        })
      },
      updateCategory(val){
        this.form.category_id = val;
      },
      updateQuestionTH(val){
        this.form.question_th = val;
      },
      updateQuestionEN(val){
        this.form.question_en = val;
      },
      updateAnswerTH(val){
        this.form.answer_th = val;
      },
      updateAnswerEN(val){
        this.form.answer_en = val;
      },
    }
  }
</script>

<style scoped>

</style>
